function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".cls-1,.primary{fill:none;}.white{fill:#fff;}.highlights{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "cls-1",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "white"
}, React.createElement("path", {
  className: "white",
  d: "M224,32V224H56a24,24,0,0,0,24-24V32Z"
}), React.createElement("path", {
  className: "white",
  d: "M80,80V200a24,24,0,0,1-48,0V80Z"
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("rect", {
  className: "highlights",
  x: 112,
  y: 64,
  width: 80,
  height: 40
})), React.createElement("g", {
  id: "primary"
}, React.createElement("path", {
  className: "primary",
  d: "M224,32V224H56a24,24,0,0,0,24-24V32Z"
}), React.createElement("path", {
  className: "primary",
  d: "M80,80V200a24,24,0,0,1-48,0V80Z"
}), React.createElement("line", {
  className: "primary",
  x1: 112,
  y1: 184,
  x2: 192,
  y2: 184
}), React.createElement("line", {
  className: "primary",
  x1: 112,
  y1: 152,
  x2: 192,
  y2: 152
}), React.createElement("rect", {
  className: "primary",
  x: 112,
  y: 64,
  width: 80,
  height: 40
})));
var SvgPrint = function SvgPrint(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPrint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Print.5eb72fa8.svg";
export { ForwardRef as ReactComponent };